var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"color":"neutralLight","no-sidebar":"","no-top-page":""}},[_c('v-container',{staticStyle:{"max-width":"35rem"}},[_c('h3',{staticClass:"font-weight-regular text-center ma-4 mb-6 pt-3 pb-2",domProps:{"textContent":_vm._s(_vm.$t('loginForm.loginAccount'))}}),_c('v-card',[_c('KYC',{attrs:{"route":_vm.$route.name}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }